var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import ThemeContext from '../../context/theme-context';
import WindowEventContext from '../../context/window-event-context';
import { getTextAlignment } from '../../helpers/styles';
import { StyledCheckbox } from '../Checkbox';
import GridLayoutItem from '../GridLayout/gridLayoutItem';
import Image from '../Image';
var StyledDiv = styled.div.attrs(function (pros) { })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var StyledListItem = styled.div.attrs(function (pros) { })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  ", "\n"], ["\n  color: ", ";\n  ",
    "\n"])), function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.listWidget.item.color;
}, function (_a) {
    var attributes = _a.attributes;
    return attributes &&
        attributes.textAlignment &&
        getTextAlignment(attributes.textAlignment);
});
var StyledOption = styled.option.attrs(function (props) { })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  background-color: ", ";\n"], ["\n  color: ", ";\n  background-color: ",
    ";\n"])), function (_a) {
    var fontColor = _a.fontColor;
    return fontColor !== null && fontColor !== void 0 ? fontColor : '';
}, function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : '';
});
var StyledTd = styled.td.attrs(function (props) { })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n  background-color: ", ";\n  ", "\n"], ["\n  color: ",
    ";\n  background-color: ",
    ";\n  ",
    "\n"])), function (_a) {
    var windowTheme = _a.windowTheme, isCellSelected = _a.isCellSelected, fontColor = _a.fontColor;
    return isCellSelected
        ? windowTheme.dataGrid.table.tbody.tr.selectedFontColor
        : fontColor !== null && fontColor !== void 0 ? fontColor : '';
}, function (_a) {
    var windowTheme = _a.windowTheme, isCellSelected = _a.isCellSelected, backgroundColor = _a.backgroundColor;
    return isCellSelected
        ? windowTheme.dataGrid.table.tbody.tr.selectedBgColor
        : backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : '';
}, function (_a) {
    var attributes = _a.attributes;
    return attributes &&
        attributes.textAlignment &&
        getTextAlignment(attributes.textAlignment);
});
var Item = function (props) {
    var attributes = props.attributes, type = props.type, parentWidget = props.parentWidget, identifier = props.identifier, childWidgets = props.childWidgets, children = props.children, colId = props.colId, _a = props.otherValues, otherValues = _a === void 0 ? {} : _a, restProps = __rest(props, ["attributes", "type", "parentWidget", "identifier", "childWidgets", "children", "colId", "otherValues"]), text = (attributes || '').text;
    var defaultItem = (React.createElement(StyledDiv, __assign({ id: identifier }, restProps),
        text,
        children));
    if (!parentWidget)
        return defaultItem;
    switch (parentWidget.type.toLowerCase()) {
        case 'optionmenu':
        case 'combobox':
        case 'qcombobox':
            return (React.createElement(StyledOption, __assign({ id: identifier }, restProps), text));
        case 'qvboxlayout':
        case 'vboxlayout':
        case 'hboxlayout':
        case 'qhboxlayout':
            return (React.createElement(StyledDiv, __assign({ id: identifier, childWidgets: childWidgets }, restProps), children));
        case 'qtablewidget':
        case 'table':
            return (React.createElement(TableItem, { identifier: identifier !== null && identifier !== void 0 ? identifier : parentWidget.identifier, otherValues: otherValues, attributes: attributes, restProps: restProps, colId: colId, text: text, rowIndex: props.rowIndex }));
        case 'gridlayout':
        case 'qgridlayout':
            return React.createElement(GridLayoutItem, __assign({}, props));
        case 'qlistwidget':
            return React.createElement(StyledListItem, __assign({}, props), text);
        default:
            return defaultItem;
    }
};
var TableItem = function (_a) {
    var identifier = _a.identifier, otherValues = _a.otherValues, attributes = _a.attributes, restProps = _a.restProps, text = _a.text, colId = _a.colId, rowIndex = _a.rowIndex;
    var _b, _c;
    var leftImages = JSON.parse((_b = otherValues[colId + "_left_images"]) !== null && _b !== void 0 ? _b : '[]');
    var rightImages = JSON.parse((_c = otherValues[colId + "_right_images"]) !== null && _c !== void 0 ? _c : '[]');
    var onClick = function (e) {
        e.stopPropagation();
    };
    return (React.createElement(StyledTd, __assign({ id: identifier, fontColor: otherValues[colId + "_fontColor"], backgroundColor: otherValues[colId + "_backgroundColor"], attributes: attributes }, restProps, { onClick: otherValues[colId + "_hasCheckbox"] ? onClick : restProps.onClick }),
        React.createElement("span", { style: { display: 'flex', alignItems: 'center' } },
            React.createElement(DisplayImages, { images: leftImages }),
            React.createElement(DisplayCheckbox, { rowIndex: rowIndex, identifier: identifier, colId: colId + "_checked", showCheckbox: otherValues[colId + "_hasCheckbox"], isChecked: otherValues[colId + "_checked"] }),
            text,
            React.createElement(DisplayImages, { images: rightImages }))));
};
var DisplayImages = function (_a) {
    var _b = _a.images, images = _b === void 0 ? [] : _b;
    if (images.length > 0) {
        return images.map(function (image) { return (React.createElement("span", { style: { padding: '0px 2px' } },
            React.createElement(Image, { height: "12", width: "12", imageName: image }))); });
    }
    return null;
};
var DisplayCheckbox = function (_a) {
    var rowIndex = _a.rowIndex, showCheckbox = _a.showCheckbox, isChecked = _a.isChecked, identifier = _a.identifier, colId = _a.colId;
    var windowTheme = React.useContext(ThemeContext);
    var _onTableCellCheckboxClick = React.useContext(WindowEventContext)._onTableCellCheckboxClick;
    if (showCheckbox) {
        return (React.createElement(StyledCheckbox, { type: "checkbox", id: identifier + "-" + rowIndex + "-" + colId.replace(/[&\/\\#, +()$~%.’“:*?\[\]<>{}\n\r]/g, '_'), geometry: {}, windowTheme: windowTheme, disabled: false, checked: isChecked, onChange: function (evt) {
                evt.stopPropagation();
                _onTableCellCheckboxClick(identifier, rowIndex, colId, !isChecked);
            } }));
    }
    return null;
};
export default Item;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map